import { combineReducers } from 'redux'

// ACTIONS
export const FETCH_DETAIL = 'company/candidateList/candidateFilters/FETCH_DETAIL'

export const RESET_ALL = 'company/candidateList/candidateFilters/RESET_ALL'

export const TOGGLE_LOADING = 'company/candidateList/candidateFilters/TOGGLE_LOADING'

// ACTION CREATORS
export const toggleLoading = loading => ({
  type: TOGGLE_LOADING,
  payload: { loading },
})

export const fetchDetail = id => ({
  type: FETCH_DETAIL,
  payload: {
    id,
  },
})

export const resetAll = () => ({
  type: RESET_ALL,
})

// REDUCERS
const defaultUtils = {
  loading: true,
  error: null,
}

const utils = (state = defaultUtils, { type, payload }) => {
  switch (type) {
    case TOGGLE_LOADING:
      return {
        ...state,
        ...payload,
      }

    case RESET_ALL:
      return defaultUtils

    default:
      return state
  }
}

export default combineReducers({
  utils,
})
